import { components, services, sizes, states } from '@/utils'

import preloader from '@/components/preloader'
import sourceBox from '@/components/source/box'
import tag from '@/components/tag'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder preloader__holder--absolute pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.state === states.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderTags(h, item) {
  return h(
    'div',
    {
      class: `${services['otp-handler']}-item__tags`
    },
    [
      h(
        tag,
        {
          props: {
            label: this.getTranslate(`${services.sendings}.types.${item.channelType}`),
            color: item.channelType,
            size: sizes.small
          }
        }
      ),
      h(
        tag,
        {
          props: {
            label: item.codeType,
            color: item.grey,
            size: sizes.small
          }
        }
      ),
      h(
        tag,
        {
          props: {
            label: item.status,
            color: item.grey,
            size: sizes.small
          }
        }
      )
    ]
  )
}
function renderSource(h, item) {
  return h(
    sourceBox,
    {
      props: {
        value: item,
        rounded: true
      }
    }
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${services['otp-handler']}-item ${services['otp-handler']}-item--channel`,
      on: {
        click: () => {
          this.item = item
          this.showDialog = true
        }
      }
    },
    [
      renderTags.call(this, h, item),
      renderSource.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${services['otp-handler']}-items ${services['otp-handler']}-items--channel`
    },
    [
      this.items.map(item => {
        return renderItem.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}

export default function(h) {
  if (this.hasItems) {
    return renderItems.call(this, h)
  } else {
    switch (this.state) {
      case states.loading: return renderPreloader.call(this, h)
      case states.ready:
      case states.success:
      default: return h(components.empty)
    }
  }
}
